// Support component names relative to this directory:
import ReactOnRails from 'react-on-rails';

import WaitlistPage from '../bundles/WaitlistPage';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  WaitlistPage,
});